import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchLeadService {
  constructor(private ws: PostmethodService) { }
  private userNameSource = new BehaviorSubject<string>(''); 
  userName$ = this.userNameSource.asObservable();

  private data = new BehaviorSubject<any>('');
  currentData: any = this.data.asObservable();
  changeData(newData: any) {
    this.data.next(newData);
  }

  getLead(queryParams: any) {
    return this.ws.wsGet(environment.baseUrl + "/lead/global-search?" + queryParams);
  }

   updateUserName(name: string) {
    this.userNameSource.next(name);
  }
}
